import { useRef, useCallback } from 'react';

function useCancellableDelayedCallback(cb, delay) {
  var timeoutRef = useRef();
  var cancel = useCallback(function () {
    var timeoutId = timeoutRef.current;

    if (timeoutId) {
      timeoutRef.current = undefined;
      clearTimeout(timeoutId);
    }
  }, [timeoutRef]);
  var delayedCb = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    timeoutRef.current = setTimeout(function () {
      return cb.apply(void 0, args);
    }, delay);
  }, [cb, delay]);
  return [delayedCb, cancel];
}

export default useCancellableDelayedCallback;
//# sourceMappingURL=useCancellableDelayedCallback.js.map
